module.exports = __webpack_public_path__ + "static/img/sjfx.97f292c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/sjfx.jpg
// module id = Z14G
// module chunks = 1